module.exports = __webpack_public_path__ + "img/wrist.24289934.png";